import { ReactNode } from 'react';

import { PolicyCardForm } from './_components/PolicyCardForm';

import { RffCheckbox } from '@cast/shared-rff-ui';

type PredictiveScalingFieldProps = {
  name: string;
  tooltipText?: ReactNode;
};

export const PredictiveScalingField = ({
  name,
  tooltipText,
}: PredictiveScalingFieldProps) => {
  return (
    <PolicyCardForm
      label="Enable predictive scaling"
      tooltipText={tooltipText}
      control={
        <RffCheckbox
          name={name}
          size="small"
          testId="enable-predictive-scaling"
        />
      }
    />
  );
};
